// extracted by mini-css-extract-plugin
module.exports = {"FullTaskScreen":"FullTaskScreen_FullTaskScreen__3W5GM","FullTaskScreenBack":"FullTaskScreen_FullTaskScreenBack__3xdpG"};